export default "__VITE_ASSET__D2QTLzJA__"